import React from 'react'
import PropTypes from 'prop-types'
import { FormControl } from 'react-bootstrap'
import SelectInput from './SelectInput'

function Select(props) {
  return (
    <FormControl
      componentClass={SelectInput}
      {...props}
    />
  )
}

Select.propTypes = {
  choices: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any,
    })
  ).isRequired,
}

export default Select



// WEBPACK FOOTER //
// ./src/components/Select/index.js